<template>
  <main id="about-us" style="background-color: #274c8e">
    <div class="bg-canvas">
      <div class="bg-gradient">
        <section
          id="faq-section"
          style="min-height: 100dvh; display: grid; place-content: center;"
        >
          <h2 class="section-header" style="color: #274c8e">
            Frequently Asked Questions
          </h2>
          <p class="section-description" style="margin-bottom: 40px">
            <span style="color: #274c8e"
              >Masih memiliki pertanyaan? Silakan hubungi tim kami melalui email
              di</span
            >
            support@efunding.id
          </p>

          <div
            v-for="(faq, index) in efundingGeneralFaq"
            :key="index"
            :ref="'faqItem' + index"
            class="mb-2"
          >
            <div
              v-b-toggle="'faq-' + index"
              variant="link"
              class="text-left faq-container"
            >
              <h1 v-html="faq.label" class="faq-title"></h1>
              <button class="nav-btn right">
                <img
                  :src="ArrowLeftIcon"
                  alt="ic-left"
                  class="nav-btn-icon"
                  :style="{ rotate: openFaqIndex === index ? '90deg' : '270deg' }"
                />
              </button>
            </div>

            <b-collapse
              :id="'faq-' + index"
              accordion="faq-accordion"
              role="tabpanel"
              @show="onFaqShow(index)"
              @shown="onFaqShown(index)"
              @hide="onFaqHide(index)"
            >
              <div v-for="(list, index) in faq.child" :key="index">
                <div class="card-item">
                  <h2 class="card-title">{{ list.title }}</h2>
                  <div class="card-description" style="color: #f0f0f0;" v-html="list.description">

                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </section>
      </div>
    </div>

    <CardGetStarted />

    <NewFooterClient />
  </main>
</template>

<script>
// Assets
import AboutUsBg from "../assets/images/landing_page/img-bg-about-us.png";
import VisionImg from "../assets/images/landing_page/img-mission.png";
import MissionImg from "../assets/images/landing_page/img-vision.png";
import ArrowLeftIcon from "../assets/images/landing_page/ic-arrow-left-orange.svg";

// Components
import CardJumboTron from "@/components/landing-page/cardJumbotron.vue";
import NewFooterClient from "@/components/landing-page/newFooterClient.vue";
import CardFaq from "@/components/landing-page/cardFaq.vue";
import CardGetStarted from "@/components/landing-page/cardGetStarted.vue";
import CardAvatarImage from "@/components/landing-page/cardAvatarImage.vue";

// Utils
import { efundingFaq } from "@/utils/efunding_faq.js";
import { efundingHierarchy } from "@/utils/efunding_hierarchy";
import { efundingGeneralFaq } from "../utils/efunding_faq_general";

export default {
  name: "Tentang",
  components: {
    CardJumboTron,
    NewFooterClient,
    CardFaq,
    CardAvatarImage,
    CardGetStarted,
    CardFaq,
  },
  data() {
    return {
      // Assets
      AboutUsBg,
      VisionImg,
      MissionImg,
      ArrowLeftIcon,

      // Data
      efundingFaq,
      efundingHierarchy,
      efundingGeneralFaq,

      // Ditambahkan untuk auto-scroll + panah berputar saat accordion FAQ
      // dibuka (sebelumnya panah statis rotate:270deg dan tidak ada scroll
      // sama sekali, jadi pertanyaan yang jauh di bawah kebuka tanpa terasa).
      openFaqIndex: null,
    };
  },
  methods: {
    onFaqShow(index) {
      // Instan — cuma buat panah langsung berputar begitu diklik, jangan
      // nunggu animasi.
      this.openFaqIndex = index;
    },
    onFaqShown(index) {
      // Ini akordeon: buka satu otomatis nutup yang lain (accordion group),
      // dan keduanya sama-sama animasi ~0.35s. Kalau scroll dihitung di
      // @show (langsung pas diklik, lihat di atas), posisi yang dipakai itu
      // posisi SEBELUM pertanyaan lain di atasnya selesai nutup/menyusut —
      // begitu animasi nutupnya jalan, halaman ikut bergeser dan hasil
      // scroll jadi meleset/"ngawur". @shown baru nembak setelah animasi
      // buka SELESAI, dan karena durasinya sama, animasi tutup di sebelah
      // biasanya juga sudah kelar di titik itu — jadi baru dihitung di sini.
      this.$nextTick(() => this.scrollToFaq(index));
    },
    onFaqHide(index) {
      if (this.openFaqIndex === index) {
        this.openFaqIndex = null;
      }
    },
    scrollToFaq(index) {
      // `ref` di dalam v-for selalu dikompilasi Vue 2 sebagai array di
      // this.$refs (refInFor) — WALAUPUN nilai ref-nya sudah unik per
      // index seperti di sini. Tanpa unwrap ini, `el` adalah [<div>], dan
      // `el.getBoundingClientRect()` di bawah akan throw lalu diam-diam
      // gagal — makanya scroll yang kelihatan jalan sebelumnya itu bukan
      // hasil hitungan kita, cuma scroll bawaan yang tidak presisi.
      const ref = this.$refs["faqItem" + index];
      const el = Array.isArray(ref) ? ref[0] : ref;
      if (!el) return;

      // Navbar-nya fixed-top (melayang, tidak makan tempat di layout), jadi
      // scrollIntoView bawaan browser akan menaruh bagian atas elemen
      // tepat ketutup navbar. Baca tinggi navbar asli (bukan angka tebakan)
      // supaya tetap benar walau tingginya berubah di breakpoint lain.
      const navbar = document.querySelector(".navbar.fixed-top");
      const offset = (navbar ? navbar.offsetHeight : 80) + 16;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.bg-canvas {
  background-image: url("../assets/images/landing_page/img-bg-canvas.png");
}
.bg-gradient {
  background: linear-gradient(
    to top,
    rgba(39, 76, 142, 1) 20%,
    rgba(39, 76, 142, 0)
  );
}
.section-header {
  color: white;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
  text-transform: capitalize;
  letter-spacing: 0;
}

.section-header-orange {
  color: #f7bd3a;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
}

.section-description {
  color: #fff;
  text-align: center;
}
.container {
  max-width: 90%;
}

.visi-misi-section {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 2rem 1rem;
}

.row-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
  margin: 0 10%;
}

.row-section.reverse {
  flex-direction: row-reverse;
}

.image {
  flex: 1;
  max-width: 400px;
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.content {
  flex: 1;
  min-width: 280px;
  max-width: 50%;
}

.title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.nav-btn {
  background: #12336c;
  border: none;
  color: white;
  font-size: 2rem;
  padding: 5px 15px;
  cursor: pointer;
  z-index: 2;
  border-radius: 100%;
}
.nav-btn-icon {
  transition: rotate 0.3s ease;
}

.card-item {
  /* Navy tint (bukan putih) — kotak ini butuh background gelap biar teks
   * deskripsi (sekarang #f0f0f0, hampir putih) kontras. Background putih
   * transparan malah menerangkan kotak dan menurunkan kontras teksnya. */
  background-color: rgba(19, 52, 108, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
.card-title {
  color: #fff;
  font-size: 20px;
  border-bottom: 1px solid #b3b3b3;
  padding-bottom: 20px;
  letter-spacing: 0;
  font-weight: 600;
  text-transform: none;
}
.card-description {
  padding-top: 20px;
  color: #f0f0f0;
  font-size: 18px;
  text-align: justify;
}

@media (max-width: 767px) {
  .card-item {
    padding: 20px;
    border: 1px solid #b3b3b3;
    border-radius: 14px;
    height: 100%;
    max-width: 100vw;
    margin-bottom: 2rem;
  }
  .faq-title {
    font-size: 18px;
    color: white;
    font-weight: 600;
    text-transform: none;
  }
  .faq-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100vw;
    max-width: 100vw;
    padding: 1rem;
    gap: 1rem;
  }
  #faq-section {
    padding: 5rem;
  }
}

@media (min-width: 768px) {
  .card-item {
    padding: 20px;
    border: 1px solid #b3b3b3;
    border-radius: 14px;
    height: 100%;
    max-width: 85vw;
    margin-bottom: 2rem;
  }
  .faq-title {
    font-size: 24px;
    color: white;
    font-weight: 600;
    margin: 20px 0;
    text-transform: none;
  }
  .faq-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    width: 85vw;
    max-width: 85vw;
  }
}

@media (min-width: 1025px) {
  .card-item {
    padding: 50px;
    border: 1px solid #b3b3b3;
    border-radius: 14px;
    height: 100%;
    max-width: 85vw;
    margin-bottom: 2rem;
  }
  .faq-title {
    font-size: 36px;
    color: white;
    font-weight: 600;
    text-transform: none;
  }
  .faq-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 85vw;
    max-width: 85vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/faq.vue